import { Modal } from 'antd';
import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const WarningDetailModal = styled(Modal)(({ theme }) => ({
  width: '553rem !important',
  '.ant-modal-content': {
    padding: '30rem',
  },
  '.ant-modal-body': {
    fontFamily: theme.typography.family.arial,
    fontSize: theme.typography.size16,
    color: theme.page.subtitle.text,
    lineHeight: 1,
  },
}));

export const WarningDetailModalTitle = styled.h2(({ theme }) => ({
  color: theme.page.title.text,
  fontFamily: theme.typography.family.playfairDisplay,
  fontSize: theme.typography.size24,
  marginBottom: '26rem',
  marginTop: 0,
  fontWeight: 'normal',
}));

export const ButtonsContainer = styled.div(() => ({
  display: 'flex',
  gap: '3rem',
  width: 'fit-content',
  marginLeft: 'auto',
}));

export const Button = styled(CommonButton)(() => ({
  paddingInline: '20rem',
  fontSize: '20rem',
}));
